import React, { useState, useEffect } from "react";
import Info from "../../InputSign/Info";

import { Container, Message } from "./styles";

const Select = (props) => {
  const [windowWidth, setWindowWidth] = useState(1000);

  useEffect(() => {
    setWindowWidth(window.innerWidth);

    window.addEventListener("resize", () => {
      setWindowWidth(window.innerWidth);
    });
  }, []);

  return (
    <Container>
      {windowWidth > 900 ? (
        <fieldset>
          <legend>
            <span>{props.title}</span>
            {props.value.info && <Info inline value={props.value.info} />}
          </legend>
          <select
            disabled={props?.disabled}
            placeholder={props.placeholder}
            value={props.value.value}
            onChange={(e) =>
              props.setValue({
                ...props.value,
                value: e.target.value,
              })
            }
          >
            <option value="" selected disabled>
              Selecione uma opção
            </option>
            {props.options.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        </fieldset>
      ) : (
        <main>
          <legend>
            <span>{props.title}</span>
            {props.value.info && <Info inline value={props.value.info} />}
          </legend>
          <select
            disabled={props?.disabled}
            placeholder={props.placeholder}
            value={props.value.value}
            onChange={(e) =>
              props.setValue({
                ...props.value,
                value: e.target.value,
              })
            }
          >
            <option value="" selected disabled>
              Selecione uma opção
            </option>
            {props.options.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        </main>
      )}

      <Message> {!props.disabled && props.value.message}</Message>
    </Container>
  );
};

export default Select;
